import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Button, Card, CardBody } from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { Switch } from "antd";
import { addBookingItem, invokeBookingKeylessKey } from "../../redux/booking/actions";

const KeylessContainer = ({ booking, hotelConfig, addBookingItem, match, invokeBookingKeylessKey }) => {

  const handleKeylessStatus = (checked) => {
    try {
      const toPatch = {
        keyless_passive: !checked,
        id: match.params.id
      };
      addBookingItem(toPatch);
    } catch (err) {
      console.error("Error in handleKeylessStatus", err);
    }
  };

  const invokeBookingKey = (index, e) => invokeBookingKeylessKey(index);

  // Burayı satırı hiçbir şekilde silme
  if (!hotelConfig.keyless_active) return (<></>)

  return (
    <Card className="mb-4 mt-4 text-center">
      <CardBody>
        <h3 className="list-item-heading mb-2">Keyless</h3>

        <div className="separator mb-2 mt-1" />

        <div>
          <div className="text-muted float-left w-50 mb-3">
            <IntlMessages id="bookingDetails.keyless_active_switch" />
          </div>

          <div className="w-50 float-right mb-3">
            {booking.keyless_passive !== undefined ? (
              <Switch
                checked={!booking.keyless_passive}
                onChange={e => handleKeylessStatus(e)}
              />
            ) : (
              <Switch
                checked
                onChange={e => handleKeylessStatus(e)}
              />
            )}
          </div>

          <div className="text-muted float-left w-50 mb-1">
            <IntlMessages id="bookingDetails.keyless_invoke" />
          </div>

          <div className="w-50 float-right mb-1">
            <Button color="primary" size="xs" onClick={e => invokeBookingKey(booking.user_id, e)}>
              <IntlMessages id="bookingDetails.keyless_invoke" />
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

const mapStateToProps = ({ settings }) => {
  const { hotelConfig } = settings;
  return { hotelConfig };
};

const mapActionsToProps = {
  addBookingItem,
  invokeBookingKeylessKey,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(KeylessContainer)
);
